import i18n from 'i18next'
import UserService from '../api/User'

type I18nResources = Record<string, Record<string, string>>

export async function loadAllTranslations(): Promise<void> {
  try {
    const response = await UserService.getLocalization()
    const backendData = response.data

    const normalizedResources = normalizeLanguageCodes(backendData)

    Object.entries(normalizedResources).forEach(([lang, translations]) => {
      i18n.addResourceBundle(lang, 'translation', translations)
    })
  } catch (error) {
    console.error('Failed to load translations:', error)
    throw error
  }
}

function normalizeLanguageCodes(data: I18nResources): I18nResources {
  const result: I18nResources = {}

  Object.entries(data).forEach(([lang, translations]) => {
    const normalizedLang = lang.toLowerCase()
    result[normalizedLang] = translations
  })

  return result
}
